import { PdfElementPreview } from '../common/PdfElementPreview';

export function PageBreakPreviewComponent() {
  return <PdfElementPreview title="Divisore di Pagina" />;
}
